import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import styled, { css } from 'styled-components';
import vendorCSS from '../../../molecules/Slider/partials/VendorCSS';
import BenefitsTile from './BenefitsTile';
import SliderButton from '../../../molecules/Slider/partials/SliderButton';
import { CopyFineprint } from '../../../atoms/Copytext';
import { gridGutter } from '~/styles/grid';
import { Headline600Skin } from '../../../atoms/Headline/HeadlineSkins';

const Wrapper = styled.div`
  ${vendorCSS};
  display: none;
  overflow-x: hidden;
  position: relative;
  padding: 0 ${gridGutter}px;
  margin-bottom: 45px;

  @media (${(props) => props.theme.benefits.mobileSwitch}) {
    display: block;
  }
`;

const SwiperWrapper = styled.div`
  .swiper-pagination {
    margin-top: -50px;
  }
`;

const ControlsBasicCss = css`
  position: absolute;
  z-index: 100;
  margin-top: -63px;
`;

const SliderButtonPrev = styled(SliderButton)`
  ${ControlsBasicCss};
  left: ${gridGutter}px;
`;

const SliderButtonNext = styled(SliderButton)`
  ${ControlsBasicCss};
  right: ${gridGutter}px;
`;

const SlideIndexWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-top: -20px;
`;

const SlideIndex = styled(CopyFineprint)`
  &::selection {
    color: ${(props) => props.theme.color.gray600};
    background-color: transparent;
  }
`;

const Headline = styled.h2`
  ${Headline600Skin};
  margin-bottom: 35px;
`;

/**
 * @param {BenefitsProps} props
 */
const MobileBenefits = ({ items, title }) => {
  /** @type {import('react').MutableRefObject<import('swiper').Swiper | null>} */
  const swiperRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper.realIndex ?? 0);
  };

  const goNext = () => {
    if (swiperRef.current !== null) {
      swiperRef.current.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current !== null) {
      swiperRef.current.slidePrev();
    }
  };

  return (
    <Wrapper>
      {title && <Headline>{title}</Headline>}
      <SwiperWrapper>
        <Swiper
          modules={[Pagination]}
          pagination={{
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true,
          }}
          loop={true}
          autoHeight={true}
          onSlideChange={handleSlideChange}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {items &&
            items.map((item, idx) => (
              <SwiperSlide key={`${idx}_benefits_tile`}>
                <BenefitsTile
                  title={item.title}
                  description={item.description}
                  icon={item.icon}
                />
              </SwiperSlide>
            ))}
        </Swiper>
      </SwiperWrapper>
      <SliderButtonPrev direction="prev" handleClick={goPrev} />
      <SliderButtonNext direction="next" handleClick={goNext} />
      <SlideIndexWrapper>
        <SlideIndex>
          {activeSlide + 1}/{items.length}
        </SlideIndex>
      </SlideIndexWrapper>
    </Wrapper>
  );
};

export default MobileBenefits;
